export const formatCep = (cep: string) => {
  if (!cep) return '';
  const numericValue = cep.replace(/\D/g, '');
  return `${numericValue.slice(0, 5)}-${numericValue.slice(5, 8)}`;
};
